export const Common = {
  SHOW_PROGRESS: "SHOW_PROGRESS",
  CLOSE_PROGRESS: "CLOSE_PROGRESS",
  SEND_EMAIL: "SEND_EMAIL",
  SET_API_RESPONSE: "SET_API_RESPONSE",
  SHOW_PRICE_CHANGED_ALERT: "SHOW_PRICE_CHANGED_ALERT",
  HIDE_PRICE_CHANGED_ALERT: "HIDE_PRICE_CHANGED_ALERT"
};
